import React, { useContext} from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { AuthContext } from "@app/providers";
import { getDefaultUrl } from "./route-helpers";
import UserConfirmation from '../components/get-started/user-confirmation'

export function PublicRoute({ children, ...rest }: any) {
  const { userInfo } = useContext(AuthContext);
  const userToken = userInfo && userInfo.sessionToken;
  const defaultUrl: string = getDefaultUrl(userInfo && userInfo.userJson);
  const location = useLocation();
  const pathData = location.pathname.split('/sign-in/');
  const pathData1 = location.pathname.split('/sign-up/')
  const resetPath = location.pathname.split('/')
  

 

  
  const confirmation = () => {
    if (!userToken) {
      return false;
    } else if ((pathData.length > 1 || pathData1.length > 1) && (pathData[1] || pathData1[1]) != userInfo.userJson.userType) {
      // console.log(  userInfo.userJson.userType,pathData[1])
      return true;
    } else {
      return false;
    }
  }
  if(location.pathname === '/resetpassword'+ '/'+ resetPath[2] + '/'+ resetPath[3]){
    return <Route
    {...rest}
    render={({ location }) =>
        children
    }
  />;
  }else{
  return (
    <>

      { confirmation() ? (
        <UserConfirmation pathData={pathData} pathData1={pathData1} />
      ) : <>
      
        <Route
          {...rest}
          render={({ location }) =>
            userToken ? (
              <Redirect
                to={{
                  pathname: defaultUrl,
                  state: { from: location },
                }}
              />
            ) : (
              children
            )
          }
        />
      </>}
    </>
  );
        }
}
